<template>
  <WdsStack gap-md align-center justify-center>
    <WdsStack direction-column>
      <WdsText small>{{ $t('Reported time') }}</WdsText>
      <span>
        <strong data-test="timesheet-stats-overview-reported-time">
          {{ timeAmounts.reported.standard }}
        </strong>
        <span
          v-if="
            !timesheetFormStore.useDayInputs &&
            timesheetFormStore.totalReportedTime &&
            timeAmounts.reported.standard !== timeAmounts.reported.hoursAndMinutes
          "
        >
          {{ ` / ${timeAmounts.reported.hoursAndMinutes}` }}
        </span>
      </span>
    </WdsStack>
    <template v-if="timeAmounts.reported.standard !== timeAmounts.payable.standard">
      <div class="tw-border-solid tw-border-[1px] tw-border-l-0 tw-border-gray-300 tw-h-5" />
      <WdsStack direction-column>
        <WdsText small>{{ $t('Total payable time') }}</WdsText>
        <span>
          <strong data-test="timesheet-stats-overview-payable-time">
            {{ timeAmounts.payable.standard }}
          </strong>
          <span
            v-if="
              !timesheetFormStore.useDayInputs &&
              timesheetFormStore.totalReportedTime &&
              timeAmounts.payable.standard !== timeAmounts.payable.hoursAndMinutes
            "
          >
            {{ ` / ${timeAmounts.payable.hoursAndMinutes}` }}
          </span>
        </span>
      </WdsStack>
      <div class="tw-border-solid tw-border-[1px] tw-border-l-0 tw-border-gray-300 tw-h-5" />
      <WdsStack direction-column>
        <WdsText small>{{ $t('Total non-payable time') }}</WdsText>
        <span>
          <strong data-test="timesheet-stats-overview-non-payable-time">
            {{ timeAmounts.nonPayable.standard }}
          </strong>
          <span
            v-if="
              !timesheetFormStore.useDayInputs &&
              timesheetFormStore.totalReportedTime &&
              timeAmounts.nonPayable.standard !== timeAmounts.nonPayable.hoursAndMinutes
            "
          >
            {{ ` / ${timeAmounts.nonPayable.hoursAndMinutes}` }}
          </span>
        </span>
      </WdsStack>
    </template>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsStack, WdsText } from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'
import { useTimesheetFormStore } from '@/components/Timesheet/store/useTimesheetFormStore'
import convertDecimalTimeToMinuteTime from '@/components/Timesheet/utilities/convertDecimalTimeToMinuteTime'
import formatFixedDecimal from '@/components/Timesheet/utilities/formatFixedDecimal'

const { $t } = useTranslation()
const timesheetFormStore = useTimesheetFormStore()

const timeAbbreviation = computed(() =>
  timesheetFormStore.useDayInputs ? $t('d (day abbreviation)') : $t('h (hour abbreviation)'),
)
const timeAmounts = computed(() => ({
  reported: {
    standard: `${formatFixedDecimal(Number(timesheetFormStore.totalReportedTime) ?? 0)}${timeAbbreviation.value}`,
    hoursAndMinutes: `${convertDecimalTimeToMinuteTime(timesheetFormStore.totalReportedTime)}`,
  },
  payable: {
    standard: `${formatFixedDecimal(Number(timesheetFormStore.totalPayableTime) ?? 0)}${timeAbbreviation.value}`,
    hoursAndMinutes: `${convertDecimalTimeToMinuteTime(timesheetFormStore.totalPayableTime)}`,
  },
  nonPayable: {
    standard: `${formatFixedDecimal(Number(timesheetFormStore.totalNonPayableTime) ?? 0)}${timeAbbreviation.value}`,
    hoursAndMinutes: `${convertDecimalTimeToMinuteTime(timesheetFormStore.totalNonPayableTime)}`,
  },
}))
</script>
